import React, { Fragment } from 'react';
import { graphql } from 'gatsby';

import { className, Row, Col } from 'aplazame-design-system';
import TransitionLink from 'aplazame-design-system/src/components/TransitionLink';

import style from './style.module.scss';

import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';

export default function BlogMetasComponent({ date, categoryPages, mb, mt }) {
    return (
        <Row
            mb={mb ? mb : { xs: 3 }}
            mt={mt ? mt : {}}
            className={`overline ${style.text} ${transitionStyle['child-link']}`}
        >
            <Col col={{ xs: 7 }}>
                {categoryPages.map((cp, i) => (
                    <Fragment key={i}>
                        {i ? `, ` : ''}
                        <TransitionLink
                            to={cp.slug}
                            {...className(
                                colorStyle['color--primary'],
                                style.tag
                            )}
                        >
                            {cp.title}
                        </TransitionLink>
                    </Fragment>
                ))}
            </Col>
            <Col className={`text-right`} col={{ xs: 5 }}>
                <span className={`${style.date}`}>{date}</span>
            </Col>
        </Row>
    );
}

export const query = graphql`
    fragment BlogItemMetas on WpPost {
        date(formatString: "L", locale: "es")
        categoryPages {
            title
            slug
        }
    }
`;
